/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeactivateAccessKeyRequestBody
 */
export interface DeactivateAccessKeyRequestBody {
    /**
     * The bearer token (API access key) to deactivate
     * @type {string}
     * @memberof DeactivateAccessKeyRequestBody
     */
    apiAccessKey: string;
}

/**
 * Check if a given object implements the DeactivateAccessKeyRequestBody interface.
 */
export function instanceOfDeactivateAccessKeyRequestBody(value: object): value is DeactivateAccessKeyRequestBody {
    let isInstance = true;
    isInstance = isInstance && "apiAccessKey" in value && value["apiAccessKey"] !== undefined;

    return isInstance;
}

export function DeactivateAccessKeyRequestBodyFromJSON(json: any): DeactivateAccessKeyRequestBody {
    return DeactivateAccessKeyRequestBodyFromJSONTyped(json, false);
}

export function DeactivateAccessKeyRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeactivateAccessKeyRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiAccessKey': json['api_access_key'],
    };
}

export function DeactivateAccessKeyRequestBodyToJSON(value?: DeactivateAccessKeyRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'api_access_key': value.apiAccessKey,
    };
}

